export function ProductHuntCard() {
    return (
        <a
            href="https://www.producthunt.com/products/deckwale-ai-presentation-builder/reviews/new?utm_source=badge-product_review&utm_medium=badge&utm_source=badge-deckwale-ai-presentation-builder"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:block transition-transform hover:scale-[1.02] active:scale-[0.98] flex-none"
        >
            <img
                src="https://api.producthunt.com/widgets/embed-image/v1/product_review.svg?product_id=1179823&theme=light"
                alt="Deckwale AI Presentation Builder | Product Hunt"
                width="210"
                height="45"
                className="opacity-90 hover:opacity-100 h-[38px] md:h-[42px] w-auto"
            />
        </a>
    )
}
